/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "pose_polisher";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface MwffFlowState {
}

export enum MwffFlowState_Enum {
  INVALID = 0,
  CANCEL = 1,
  INTERMEDIATE = 2,
  COMPLETE = 3,
  UNRECOGNIZED = -1,
}

export function mwffFlowState_EnumFromJSON(object: any): MwffFlowState_Enum {
  switch (object) {
    case 0:
    case "INVALID":
      return MwffFlowState_Enum.INVALID;
    case 1:
    case "CANCEL":
      return MwffFlowState_Enum.CANCEL;
    case 2:
    case "INTERMEDIATE":
      return MwffFlowState_Enum.INTERMEDIATE;
    case 3:
    case "COMPLETE":
      return MwffFlowState_Enum.COMPLETE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return MwffFlowState_Enum.UNRECOGNIZED;
  }
}

export function mwffFlowState_EnumToJSON(object: MwffFlowState_Enum): string {
  switch (object) {
    case MwffFlowState_Enum.INVALID:
      return "INVALID";
    case MwffFlowState_Enum.CANCEL:
      return "CANCEL";
    case MwffFlowState_Enum.INTERMEDIATE:
      return "INTERMEDIATE";
    case MwffFlowState_Enum.COMPLETE:
      return "COMPLETE";
    case MwffFlowState_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseMwffFlowState(): MwffFlowState {
  return {};
}

export const MwffFlowState = {
  encode(_: MwffFlowState, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): MwffFlowState {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMwffFlowState();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): MwffFlowState {
    return {};
  },

  toJSON(_: MwffFlowState): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<MwffFlowState>, I>>(base?: I): MwffFlowState {
    return MwffFlowState.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MwffFlowState>, I>>(_: I): MwffFlowState {
    const message = createBaseMwffFlowState();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
